/**
 * 050: format a minor-unit amount for display, using the currency symbol the API
 * published alongside the rate rather than a hardcoded `RM` (FR-010).
 *
 * Returns `null` for a missing amount so a caller can omit the whole line instead
 * of rendering a zero price — an unpriced car must show no price at all (FR-008).
 */
export function formatMinor(minor: number | null | undefined, symbol = 'RM'): string | null {
  if (typeof minor !== 'number' || !Number.isFinite(minor)) return null;
  const major = minor / 100;
  const text = Number.isInteger(major) ? String(major) : major.toFixed(2);
  return `${symbol} ${text}`;
}
